import { Dictionary } from 'lodash'
import { isIndia } from 'utils/commonUtils'

import {
  AGENT_COLLECTION,
  AGENT_CUSTOMER,
  AGENT_GROUP,
  AGENT_INCENTIVES,
  AGENT_MANAGEMENT,
  AGENTS_PERFORMANCE,
  // AGENTS_PERFORMANCE,
  AUTO_INVENTORY_REPLENISHMENT,
  AUTOMATIC_PARTIAL_FULFILLMENT,
  BIDDING_INVITATION_LIST,
  BIDDING_REQUEST,
  BRAND_PORTAL,
  BUY_IN_INVOICE,
  CATEGORY_INSIGHTS,
  CLAIMS_MANAGEMENT,
  COLLECTION_MANAGEMENT,
  CONFIG_CM3_TARGET,
  CONFIRM_COLLECTION,
  CONSIGNMENT_CASH_RECONCILIATION,
  CONSOLIDATED_PURCHASE_REQUEST,
  COVERAGE_REPORT,
  CREDIT_DEBIT_NOTE,
  CREDIT_INFORMATION,
  CREDIT_MANAGEMENT,
  CREDIT_OUTSTANDING_REPORT,
  // COVERAGE_REPORT,
  DELIVERY_MANAGEMENT,
  DELIVERY_MANAGEMENT_HUB,
  DELIVERY_PERFORMANCE,
  // DELIVERY_PERFORMANCE,
  DISTRIBUTOR_CENTER,
  DISTRIBUTOR_CONTRACT_FEE,
  DISTRIBUTOR_FEE,
  DISTRIBUTOR_LIST,
  DISTRIBUTOR_MANAGEMENT,
  DISTRIBUTOR_MARGIN,
  DISTRIBUTOR_OUTLET,
  DISTRIBUTOR_PROFILE,
  DISTRIBUTOR_PURCHASE_ORDER,
  DISTRIBUTOR_PURCHASE_REQUEST,
  DISTRIBUTOR_REGISTER,
  DISTRIBUTOR_VIGO_QUOTATION,
  FAILED_DELIVERY_RECEIVE,
  FINANCE_TASK_LIST,
  FULFILLMENTS,
  GOODS_NOT_FOCUS,
  HOME,
  INBOUND_LIST,
  INCENTIVES_CONFIG,
  INVENTORY_ADJUSTMENT,
  INVENTORY_ALLOCATE,
  INVENTORY_ALLOCATION,
  INVENTORY_DISTRIBUTOR_AGENT,
  INVENTORY_LIST,
  INVENTORY_LOCATIONS,
  INVENTORY_RECOMMEND,
  INVENTORY_REPORT,
  MANUFACTORY,
  MANUFACTURING_ORDER,
  // INVENTORY_REPORT,
  MARKETING,
  MARKETING_BUDGET,
  MASTER_DATA,
  MISSION_PERFORMANCE,
  MT_PURCHASE_ORDER,
  ORDER_LIST,
  OUTLETS_PERFORMANCE,
  // OUTLETS_PERFORMANCE,
  PACKAGE_LIST,
  PARTNER,
  PAYMENT_REQUEST,
  PAYOUT_STATEMENT,
  PICKLIST_ASSIGNMENT,
  PICKLIST_CHECKOUT,
  PRE_ORDERS,
  PRICE_MANAGEMENT,
  PRICE_TYPE_CONFIG,
  PROCUREMENT_CONFIG,
  PRODUCT_AVAILABLE,
  PRODUCT_LIST,
  PRODUCT_LISTING,
  PRODUCT_PRE_ORDER,
  PRODUCT_TRADING_BY_LISTING,
  PURCHASE_ORDER_LIST,
  PURCHASING,
  REASON_CANCEL,
  REASON_NEED_ADJUST,
  REMITTANCE_LIST,
  REPORT,
  REPORT_CLAIM,
  REPORT_CLAIMS,
  REPORT_CLAIMS_RETURN,
  REPORT_DISTRIBUTOR_RECONCILIATION,
  REPORT_DISTRIBUTOR_RECONCILIATION_SUMMARY,
  REPORT_GST_PURCHASE_REGISTER,
  REPORT_GST_PURCHASES,
  REPORT_GST_SALES,
  REPORT_GST_SALES_HUB,
  REPORT_GST_SALES_REGISTER_DETAILED_HUB,
  REPORT_GST_SALES_REGISTER_HUB,
  REPORT_GST_SALES_RETURN,
  REPORT_GST_SALES_RETURN_HUB,
  REPORT_GST_SALES_RETURN_SUMMARY,
  REPORT_GST_SUMMARY_BY_HSN,
  REPORT_GSTR_SALES_REGISTER,
  REPORT_GSTR_SALES_REGISTER_SUMMARY,
  REPORT_INVENTORY,
  REPORT_INVENTORY_SNAPSHOT,
  REPORT_INVOICE_LOADING,
  REPORT_PRODUCT_SUMMARY,
  REPORT_PURCHASE_RECONCILIATION,
  REPORT_PURCHASE_REGISTER_DETAILED,
  REPORT_PURCHASE_RETURN,
  REPORT_RIDER,
  REPORT_SALES_SUMMARY,
  REPORT_SALES_SUMMARY_OUTLET,
  REPORT_SALES_SUMMARY_SKU,
  REPORT_SUMMARY,
  RETAIL_PURCHASE_REQUEST_LIST,
  RETURN_ORDER_LIST,
  RIDER,
  RIDER_MANAGEMENT,
  SALES_PERFORMANCE,
  SELL_OUT_INVOICE,
  SETTINGS,
  STOCK_TRANSFER,
  STOCK_TRANSPORT_ORDER,
  SUBSIDY_RULE,
  SUPPLIER_INVOICE_PRODUCT_MANAGEMENT,
  SUPPLIER_LIST,
  SUPPLIER_LIST_VN,
  SUPPLIER_PORTAL,
  SUPPLIER_PRODUCT_LIST,
  TASK_LIST,
  TAX_MANAGEMENT,
  TOTAL_INVENTORY_REPORT,
  TOTAL_PURCHASE_VALUE_REPORT,
  TRADE_ORDERS,
  TRANSPORTATION_VENDOR,
  USER_LIST,
  VEHICLE_MANAGEMENT,
  VIGO_DELIVERY,
  VIGO_MASTER_QUOTATION,
  VIGO_PURCHASE_ORDER,
  WAREHOUSE_LIST,
  WAREHOUSE_WMS_LIST,
  WMS,
} from './routes'

export const ADMIN_ROLE = 'administrator'
export const EXTERNAL_DISTRIBUTOR = 'external_distributor'
export const EXTERNAL_SUPPLIER = 'external_supplier'
export const BGM = 'po_agent'
export const BRAND_MANAGER = 'brand_manager'
export const MARKETING_ROLE = 'marketing'
export const PO_MANAGER = 'po_manager'
export const FINANCE = 'finance'
export const FINANCE_ROLE = 'finance'
export const CONTENT = 'content'
export const RIDER_ROLE = 'rider'
export const GUEST = 'guest'
export const SOURCING_MANAGER = 'sourcing_manager'
export const LOGISTICS_MANAGER = 'logistics_manager'
export const MASTER_DISTRIBUTOR_HUB = 'master_distributor_hub'
export const EXTERNAL_DISTRIBUTOR_GROUP = 'external_distributor_group'
export const ADMIN_MARKETPLACE = 'administrator_marketplace'
export const DISTRIBUTOR_STAFF = 'distributor_staff'
export const SALE_SUPERVISOR = 'sale_supervisor'
export const HUB_MANAGER = 'hub_manager'
export const CATEGORY_MAN = 'category_man'
export const BEE = 'bee'
export const MT = 'mt'

const ACL: Dictionary<string[]> = {
  [ADMIN_ROLE]: ['*'], // all access
  [BEE]: [
    PRODUCT_AVAILABLE,
    PRODUCT_LISTING,
    PRODUCT_PRE_ORDER,
    PRODUCT_TRADING_BY_LISTING,
    SUPPLIER_LIST_VN,
    AGENT_MANAGEMENT,
    AGENT_COLLECTION,
    SALES_PERFORMANCE,
    CATEGORY_INSIGHTS,
    DELIVERY_PERFORMANCE,
    INVENTORY_REPORT,
    AGENTS_PERFORMANCE,
    OUTLETS_PERFORMANCE,
    COVERAGE_REPORT,
    PRICE_MANAGEMENT,
    MISSION_PERFORMANCE,
    PURCHASING,
    DISTRIBUTOR_CENTER,
    DISTRIBUTOR_PURCHASE_REQUEST,
    DISTRIBUTOR_PURCHASE_ORDER,
    CONSOLIDATED_PURCHASE_REQUEST,
    VIGO_MASTER_QUOTATION,
    VIGO_PURCHASE_ORDER,
    INVENTORY_RECOMMEND,
    REASON_CANCEL,
    CONFIG_CM3_TARGET,
    TRANSPORTATION_VENDOR,
    VIGO_DELIVERY,
    WAREHOUSE_WMS_LIST,
    INBOUND_LIST,
    INVENTORY_LIST,
    INVENTORY_LOCATIONS,
    INVENTORY_DISTRIBUTOR_AGENT,
    INVENTORY_ALLOCATION,
    TRADE_ORDERS,
    PRE_ORDERS,
    ORDER_LIST,
    PICKLIST_ASSIGNMENT,
    BUY_IN_INVOICE,
    SELL_OUT_INVOICE,
    PAYOUT_STATEMENT,
    FINANCE_TASK_LIST,
    PAYMENT_REQUEST,
    PRICE_TYPE_CONFIG,
    TAX_MANAGEMENT,
    RIDER_MANAGEMENT,
    VEHICLE_MANAGEMENT,
    DELIVERY_MANAGEMENT,
    PACKAGE_LIST,
    FAILED_DELIVERY_RECEIVE,
    REMITTANCE_LIST,
    DISTRIBUTOR_PROFILE,
    DISTRIBUTOR_REGISTER,
    REPORT_RIDER,
    MARKETING_BUDGET,
    SUBSIDY_RULE,
    TASK_LIST,
    MANUFACTORY,
    MANUFACTURING_ORDER,
  ],
  [MT]: [
    PRODUCT_AVAILABLE,
    PRODUCT_LISTING,
    PRODUCT_PRE_ORDER,
    PRODUCT_TRADING_BY_LISTING,
    SUPPLIER_LIST_VN,
    AGENT_MANAGEMENT,
    AGENT_COLLECTION,
    SALES_PERFORMANCE,
    CATEGORY_INSIGHTS,
    DELIVERY_PERFORMANCE,
    INVENTORY_REPORT,
    AGENTS_PERFORMANCE,
    OUTLETS_PERFORMANCE,
    COVERAGE_REPORT,
    PRICE_MANAGEMENT,
    MISSION_PERFORMANCE,
    PURCHASING,
    DISTRIBUTOR_CENTER,
    MT_PURCHASE_ORDER,
    DISTRIBUTOR_PURCHASE_REQUEST,
    DISTRIBUTOR_PURCHASE_ORDER,
    CONSOLIDATED_PURCHASE_REQUEST,
    VIGO_MASTER_QUOTATION,
    VIGO_PURCHASE_ORDER,
    INVENTORY_RECOMMEND,
    REASON_CANCEL,
    CONFIG_CM3_TARGET,
    TRANSPORTATION_VENDOR,
    VIGO_DELIVERY,
    WAREHOUSE_WMS_LIST,
    INBOUND_LIST,
    INVENTORY_LIST,
    INVENTORY_DISTRIBUTOR_AGENT,
    INVENTORY_ALLOCATION,
    TRADE_ORDERS,
    PRE_ORDERS,
    ORDER_LIST,
    PICKLIST_ASSIGNMENT,
    BUY_IN_INVOICE,
    SELL_OUT_INVOICE,
    PAYOUT_STATEMENT,
    FINANCE_TASK_LIST,
    PAYMENT_REQUEST,
    PRICE_TYPE_CONFIG,
    TAX_MANAGEMENT,
    RIDER_MANAGEMENT,
    VEHICLE_MANAGEMENT,
    DELIVERY_MANAGEMENT,
    PACKAGE_LIST,
    FAILED_DELIVERY_RECEIVE,
    REMITTANCE_LIST,
    DISTRIBUTOR_PROFILE,
    DISTRIBUTOR_REGISTER,
    REPORT_RIDER,
    MARKETING_BUDGET,
    SUBSIDY_RULE,
    TASK_LIST,
  ],
  [CATEGORY_MAN]: [
    PRODUCT_AVAILABLE,
    PRODUCT_LISTING,
    PRODUCT_PRE_ORDER,
    PRODUCT_TRADING_BY_LISTING,
    SUPPLIER_LIST_VN,
    SALES_PERFORMANCE,
    CATEGORY_INSIGHTS,
    DELIVERY_PERFORMANCE,
    INVENTORY_REPORT,
    AGENTS_PERFORMANCE,
    OUTLETS_PERFORMANCE,
    COVERAGE_REPORT,
    PRICE_MANAGEMENT,
    MISSION_PERFORMANCE,
    PURCHASING,
    DISTRIBUTOR_CENTER,
    DISTRIBUTOR_VIGO_QUOTATION,
    DISTRIBUTOR_PURCHASE_REQUEST,
    VIGO_MASTER_QUOTATION,
    DISTRIBUTOR_PURCHASE_ORDER,
    VIGO_PURCHASE_ORDER,
    INVENTORY_RECOMMEND,
    CONFIG_CM3_TARGET,
    TRANSPORTATION_VENDOR,
    VIGO_DELIVERY,
    INBOUND_LIST,
    INVENTORY_LIST,
    TRADE_ORDERS,
    PICKLIST_ASSIGNMENT,
    ORDER_LIST,
    PRE_ORDERS,
    BUY_IN_INVOICE,
    RIDER_MANAGEMENT,
    DELIVERY_MANAGEMENT,
    VEHICLE_MANAGEMENT,
    FAILED_DELIVERY_RECEIVE,
    PACKAGE_LIST,
    REMITTANCE_LIST,
    DISTRIBUTOR_PROFILE,
    DISTRIBUTOR_REGISTER,
    REPORT_RIDER,
    MARKETING_BUDGET,
    SUBSIDY_RULE,
    AGENT_GROUP,
    INCENTIVES_CONFIG,
    AGENT_INCENTIVES,
    USER_LIST,
    SETTINGS,
    TASK_LIST,
    PROCUREMENT_CONFIG,
    MANUFACTORY,
    MANUFACTURING_ORDER,
  ],
  [SALE_SUPERVISOR]: [
    PURCHASING,
    DISTRIBUTOR_VIGO_QUOTATION,
    PACKAGE_LIST,
    PICKLIST_ASSIGNMENT,
    INBOUND_LIST,

    // Master Data
    DISTRIBUTOR_LIST,
    PRODUCT_LIST,
    SUPPLIER_LIST,
    SUPPLIER_PRODUCT_LIST,
    WAREHOUSE_LIST,
    WAREHOUSE_WMS_LIST,
    PRODUCT_LISTING,
    PRODUCT_TRADING_BY_LISTING,
    PRODUCT_AVAILABLE,
    // Supplier Portal
    SUPPLIER_PORTAL,
    RETAIL_PURCHASE_REQUEST_LIST,
    PURCHASE_ORDER_LIST,
    TASK_LIST,
    BIDDING_REQUEST,
    WMS,
    AUTO_INVENTORY_REPLENISHMENT,
    INVENTORY_DISTRIBUTOR_AGENT,
    FULFILLMENTS,
    ORDER_LIST,
    PRE_ORDERS,
    TRADE_ORDERS,
    PICKLIST_CHECKOUT,
    MARKETING,
    SUBSIDY_RULE,
    PURCHASING,
    CONSOLIDATED_PURCHASE_REQUEST,
    MARKETING_BUDGET,
    DISTRIBUTOR_MANAGEMENT,
    DISTRIBUTOR_PROFILE,
    STOCK_TRANSFER,
    PARTNER,
    SUPPLIER_LIST_VN,
    INVENTORY_LIST,
    INVENTORY_ALLOCATION,
    AGENT_MANAGEMENT,
    AGENT_COLLECTION,
    VIGO_MASTER_QUOTATION,
  ],
  [BRAND_MANAGER]: [
    BRAND_PORTAL,
    SALES_PERFORMANCE,
    CATEGORY_INSIGHTS,
    // DELIVERY_PERFORMANCE,
    INVENTORY_REPORT,
    // AGENTS_PERFORMANCE,
    // OUTLETS_PERFORMANCE,
    // COVERAGE_REPORT,
    PRICE_MANAGEMENT,
    MISSION_PERFORMANCE,
    TRADE_ORDERS,
    PRODUCT_AVAILABLE,
  ],
  [EXTERNAL_DISTRIBUTOR]: [
    PRODUCT_TRADING_BY_LISTING,
    PRODUCT_AVAILABLE,
    WMS,
    AUTO_INVENTORY_REPLENISHMENT,
    INBOUND_LIST,
    WAREHOUSE_WMS_LIST,
    TASK_LIST,
    FULFILLMENTS,
    ORDER_LIST,
    PRE_ORDERS,
    PICKLIST_ASSIGNMENT,
    PICKLIST_CHECKOUT,
    RIDER,
    RIDER_MANAGEMENT,
    PACKAGE_LIST,
    DELIVERY_MANAGEMENT,
    FAILED_DELIVERY_RECEIVE,
    VEHICLE_MANAGEMENT,
    REMITTANCE_LIST,
    DISTRIBUTOR_MANAGEMENT,
    DISTRIBUTOR_PROFILE,
    REPORT,
    REPORT_RIDER,
    REPORT_DISTRIBUTOR_RECONCILIATION,
    REPORT_DISTRIBUTOR_RECONCILIATION_SUMMARY,
    MASTER_DATA,
    PRODUCT_LISTING,
    BUY_IN_INVOICE,
    SELL_OUT_INVOICE,
    MARKETING,
    SUBSIDY_RULE,
    DISTRIBUTOR_CENTER,
    PURCHASING,
    INVENTORY_LIST,
    RETURN_ORDER_LIST,
    CREDIT_DEBIT_NOTE,
    MARKETING_BUDGET,
    STOCK_TRANSFER,
    INVENTORY_ALLOCATION,
    INVENTORY_DISTRIBUTOR_AGENT,
    AGENT_MANAGEMENT,
    AGENT_COLLECTION,
  ],
  [EXTERNAL_SUPPLIER]: [
    PURCHASE_ORDER_LIST,
    SUPPLIER_PORTAL,
    SUPPLIER_PRODUCT_LIST,
    BIDDING_INVITATION_LIST,
    PRODUCT_AVAILABLE,
    TOTAL_INVENTORY_REPORT,
    TOTAL_PURCHASE_VALUE_REPORT,
    CONSIGNMENT_CASH_RECONCILIATION,
  ],
  [BGM]: [
    // Master Data
    DISTRIBUTOR_LIST,
    PRODUCT_LIST,
    SUPPLIER_LIST,
    SUPPLIER_PRODUCT_LIST,
    WAREHOUSE_LIST,
    WAREHOUSE_WMS_LIST,
    PRODUCT_LISTING,
    PRODUCT_TRADING_BY_LISTING,
    PRODUCT_AVAILABLE,
    // Supplier Portal
    SUPPLIER_PORTAL,
    RETAIL_PURCHASE_REQUEST_LIST,
    PURCHASE_ORDER_LIST,
    TASK_LIST,
    BIDDING_REQUEST,
    WMS,
    AUTO_INVENTORY_REPLENISHMENT,
    INBOUND_LIST,
    FULFILLMENTS,
    ORDER_LIST,
    PRE_ORDERS,
    TRADE_ORDERS,
    PICKLIST_ASSIGNMENT,
    PICKLIST_CHECKOUT,
    MARKETING,
    SUBSIDY_RULE,
    PURCHASING,
    MARKETING_BUDGET,
    DISTRIBUTOR_MANAGEMENT,
    DISTRIBUTOR_PROFILE,
    STOCK_TRANSFER,
    PARTNER,
    SUPPLIER_LIST_VN,
    INVENTORY_LIST,
    CONSOLIDATED_PURCHASE_REQUEST,
    VIGO_MASTER_QUOTATION,
  ],
  [PO_MANAGER]: [
    INBOUND_LIST,
    PURCHASE_ORDER_LIST,
    SUPPLIER_PORTAL,
    BIDDING_REQUEST,
    TASK_LIST,
    WMS,
    DISTRIBUTOR_PURCHASE_REQUEST,
    CONSOLIDATED_PURCHASE_REQUEST,
    VIGO_MASTER_QUOTATION,
    DISTRIBUTOR_PURCHASE_ORDER,
    VIGO_PURCHASE_ORDER,
    PRODUCT_AVAILABLE,
  ],
  [FINANCE]: [
    MARKETING_BUDGET,
    SUPPLIER_PORTAL,
    PURCHASE_ORDER_LIST,
    PRODUCT_TRADING_BY_LISTING,
    MT_PURCHASE_ORDER,
    WMS,
    INBOUND_LIST,
    INVENTORY_LIST,
    BUY_IN_INVOICE,
    SELL_OUT_INVOICE,
    PAYMENT_REQUEST,
    TASK_LIST,
    PACKAGE_LIST,
    PRODUCT_LISTING,
    MARKETING,
    SUBSIDY_RULE,
    TAX_MANAGEMENT,
    SUPPLIER_INVOICE_PRODUCT_MANAGEMENT,
    DISTRIBUTOR_CONTRACT_FEE,
    TRADE_ORDERS,
    // Logistics
    TRANSPORTATION_VENDOR,
    VIGO_DELIVERY,
    PAYOUT_STATEMENT,
    FINANCE_TASK_LIST,
    VIGO_PURCHASE_ORDER,
    REASON_NEED_ADJUST,
    PRICE_TYPE_CONFIG,
    TOTAL_INVENTORY_REPORT,
    TOTAL_PURCHASE_VALUE_REPORT,
    CONSIGNMENT_CASH_RECONCILIATION,
    DISTRIBUTOR_FEE,
  ],
  [CONTENT]: [
    SUPPLIER_PORTAL,
    PURCHASE_ORDER_LIST,
    WMS,
    INBOUND_LIST,
    INVENTORY_LIST,
  ],
  [RIDER_ROLE]: [HOME],
  [GUEST]: [HOME],
  [SOURCING_MANAGER]: [
    // Master Data
    PRODUCT_LIST,
    SUPPLIER_LIST,
    PRODUCT_PRE_ORDER,
    PRODUCT_TRADING_BY_LISTING,
    INVENTORY_RECOMMEND,
    PRODUCT_LISTING,
    PRODUCT_AVAILABLE,
    // Supplier Portal
    PURCHASE_ORDER_LIST,
    BIDDING_REQUEST,
    BIDDING_INVITATION_LIST,
    TOTAL_INVENTORY_REPORT,
    TOTAL_PURCHASE_VALUE_REPORT,
    CONSIGNMENT_CASH_RECONCILIATION,
    //PROCUREMENT,
    DISTRIBUTOR_PURCHASE_REQUEST,
    CONSOLIDATED_PURCHASE_REQUEST,
    VIGO_MASTER_QUOTATION,
    DISTRIBUTOR_PURCHASE_ORDER,
    VIGO_PURCHASE_ORDER,
    GOODS_NOT_FOCUS,
    AUTOMATIC_PARTIAL_FULFILLMENT,
    CONFIG_CM3_TARGET,
    // Logistics
    TRANSPORTATION_VENDOR,
    TRADE_ORDERS,
    //marketing
    MARKETING,
    SUBSIDY_RULE,
    PARTNER,
    SUPPLIER_LIST_VN,
    TASK_LIST,
    MANUFACTORY,
    MANUFACTURING_ORDER,
  ],
  [LOGISTICS_MANAGER]: [
    // Master Data
    PRODUCT_LIST,
    SUPPLIER_LIST,
    WAREHOUSE_LIST,
    DISTRIBUTOR_LIST,
    DISTRIBUTOR_MANAGEMENT,
    DISTRIBUTOR_PROFILE,
    // Supplier Portal
    PURCHASE_ORDER_LIST,
    //procurement
    VIGO_MASTER_QUOTATION,
    DISTRIBUTOR_PURCHASE_ORDER,
    VIGO_PURCHASE_ORDER,
    //wms
    WMS,
    STOCK_TRANSPORT_ORDER,
    // Logistics
    TRANSPORTATION_VENDOR,
    VIGO_DELIVERY,
    // WMS
    INVENTORY_LOCATIONS,
    // Settings
    TASK_LIST,
    PARTNER,
    SUPPLIER_LIST_VN,
    MANUFACTORY,
    MANUFACTURING_ORDER,
    WMS,
    INVENTORY_ALLOCATE,
  ],
  [MASTER_DISTRIBUTOR_HUB]: [
    // Master Data
    SUPPLIER_PRODUCT_LIST,
    // Supplier Portal
    PURCHASE_ORDER_LIST,
    // WMS
    INBOUND_LIST,
    // Return
    RETURN_ORDER_LIST,
    CREDIT_DEBIT_NOTE,
  ],
  [MARKETING_ROLE]: [
    PAYOUT_STATEMENT,
    AGENT_INCENTIVES,
    INCENTIVES_CONFIG,
    AGENT_GROUP,
    TRADE_ORDERS,
    ORDER_LIST,
  ],
  [ADMIN_MARKETPLACE]: [
    INVENTORY_LIST,
    INBOUND_LIST,
    FULFILLMENTS,
    TRADE_ORDERS,
    ORDER_LIST,
    PICKLIST_ASSIGNMENT,
    RIDER,
    RIDER_MANAGEMENT,
    VEHICLE_MANAGEMENT,
    DELIVERY_MANAGEMENT,
    PACKAGE_LIST,
    DISTRIBUTOR_MANAGEMENT,
    DISTRIBUTOR_PROFILE,
    DISTRIBUTOR_REGISTER,
    PRODUCT_AVAILABLE,
    PRODUCT_LISTING,
  ],
}
const ACL_INDIA: Dictionary<string[]> = {
  [ADMIN_ROLE]: ['*'], // all access
  [HUB_MANAGER]: [
    PURCHASE_ORDER_LIST,
    INBOUND_LIST,
    INVENTORY_LIST,
    PICKLIST_ASSIGNMENT,
    ORDER_LIST,
    VEHICLE_MANAGEMENT,
    RIDER_MANAGEMENT,
    DELIVERY_MANAGEMENT_HUB,
    RETURN_ORDER_LIST,
    REPORT_INVENTORY_SNAPSHOT,
    REPORT_INVENTORY,
  ],
  [DISTRIBUTOR_STAFF]: [
    INBOUND_LIST,
    INVENTORY_LIST,
    PICKLIST_ASSIGNMENT,
    ORDER_LIST,
    PACKAGE_LIST,
    DELIVERY_MANAGEMENT,
    REPORT,
    REPORT_CLAIMS,
    REPORT_GST_PURCHASES,
    REPORT_GST_SALES,
    REPORT_SUMMARY,
    REPORT_SALES_SUMMARY,
    RIDER_MANAGEMENT,
    VEHICLE_MANAGEMENT,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_SALES_SUMMARY_OUTLET,
    REPORT_SALES_SUMMARY_SKU,
    REPORT_PURCHASE_RETURN,
    REPORT_PRODUCT_SUMMARY,
    REPORT_INVOICE_LOADING,
    REPORT_GST_SUMMARY_BY_HSN,
    REPORT_GST_SALES_RETURN,
    REPORT_GST_SALES_REGISTER_HUB,
    REPORT_GSTR_SALES_REGISTER,
    REPORT_GSTR_SALES_REGISTER_SUMMARY,
    REPORT_GST_SALES_RETURN_SUMMARY,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_CLAIMS_RETURN,
    REPORT_CLAIM,
    REPORT_PURCHASE_REGISTER_DETAILED,
  ],
  [EXTERNAL_DISTRIBUTOR]: [
    INVENTORY_ADJUSTMENT,
    PURCHASE_ORDER_LIST,
    RETAIL_PURCHASE_REQUEST_LIST,
    RETURN_ORDER_LIST,
    CREDIT_DEBIT_NOTE,
    PRE_ORDERS,
    WMS,
    INBOUND_LIST,
    FULFILLMENTS,
    ORDER_LIST,
    PICKLIST_ASSIGNMENT,
    PICKLIST_CHECKOUT,
    RIDER,
    RIDER_MANAGEMENT,
    PACKAGE_LIST,
    DELIVERY_MANAGEMENT,
    FAILED_DELIVERY_RECEIVE,
    VEHICLE_MANAGEMENT,
    REMITTANCE_LIST,
    REPORT,
    REPORT_RIDER,
    REPORT_CLAIMS,
    REPORT_GST_PURCHASES,
    REPORT_GST_SALES,
    REPORT_INVENTORY,
    REPORT_SUMMARY,
    REPORT_SALES_SUMMARY,
    BUY_IN_INVOICE,
    SELL_OUT_INVOICE,
    DISTRIBUTOR_CENTER,
    PURCHASING,
    CREDIT_INFORMATION,
    CREDIT_MANAGEMENT,
    CREDIT_OUTSTANDING_REPORT,
    INVENTORY_LIST,
    CLAIMS_MANAGEMENT,
    AGENT_CUSTOMER,
    DISTRIBUTOR_OUTLET,
    CONFIRM_COLLECTION,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_SALES_SUMMARY_OUTLET,
    REPORT_SALES_SUMMARY_SKU,
    REPORT_PURCHASE_RETURN,
    REPORT_PURCHASE_RECONCILIATION,
    REPORT_PRODUCT_SUMMARY,
    REPORT_INVOICE_LOADING,
    REPORT_INVENTORY_SNAPSHOT,
    REPORT_GST_SUMMARY_BY_HSN,
    REPORT_GST_SALES_RETURN,
    REPORT_GST_SALES_REGISTER_HUB,
    REPORT_GSTR_SALES_REGISTER,
    REPORT_GSTR_SALES_REGISTER_SUMMARY,
    REPORT_GST_SALES_RETURN_SUMMARY,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_CLAIMS_RETURN,
    REPORT_CLAIM,
    COLLECTION_MANAGEMENT,
    REPORT_PURCHASE_REGISTER_DETAILED,
  ],

  [EXTERNAL_SUPPLIER]: [
    PURCHASE_ORDER_LIST,
    SUPPLIER_PORTAL,
    SUPPLIER_PRODUCT_LIST,
    BIDDING_INVITATION_LIST,
    RETURN_ORDER_LIST,
  ],

  [BGM]: [
    INVENTORY_ADJUSTMENT,
    RETAIL_PURCHASE_REQUEST_LIST,
    RETURN_ORDER_LIST,
    // Master Data
    DISTRIBUTOR_LIST,
    PRODUCT_LIST,
    SUPPLIER_LIST,
    SUPPLIER_PRODUCT_LIST,
    WAREHOUSE_LIST,
    PRODUCT_LISTING,
    PAYOUT_STATEMENT,
    FINANCE_TASK_LIST,
    REPORT_CLAIMS,
    REPORT_GST_PURCHASES,
    REPORT_GST_SALES,
    REPORT_GST_SALES_HUB,
    REPORT_INVENTORY,
    REPORT_SUMMARY,
    // Supplier Portal
    PRE_ORDERS,
    TRADE_ORDERS,
    FULFILLMENTS,
    ORDER_LIST,
    PICKLIST_ASSIGNMENT,
    PICKLIST_CHECKOUT,
    SUPPLIER_PORTAL,
    PURCHASE_ORDER_LIST,
    BIDDING_REQUEST,
    WMS,
    MARKETING_BUDGET,
    INBOUND_LIST,
    INVENTORY_LIST,
    FULFILLMENTS,
    MARKETING,
    INVENTORY_LIST,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_SALES_SUMMARY_OUTLET,
    REPORT_SALES_SUMMARY_SKU,
    REPORT_PURCHASE_RETURN,
    REPORT_PURCHASE_RECONCILIATION,
    REPORT_PRODUCT_SUMMARY,
    REPORT_INVOICE_LOADING,
    REPORT_INVENTORY_SNAPSHOT,
    REPORT_GST_SUMMARY_BY_HSN,
    REPORT_GST_SALES_RETURN_HUB,
    REPORT_GST_SALES_RETURN,
    REPORT_GST_SALES_REGISTER_HUB,
    REPORT_GST_SALES_REGISTER_DETAILED_HUB,
    REPORT_GSTR_SALES_REGISTER,
    REPORT_GSTR_SALES_REGISTER_SUMMARY,
    REPORT_GST_SALES_RETURN_SUMMARY,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_CLAIMS_RETURN,
    REPORT_CLAIM,
    REPORT_PURCHASE_REGISTER_DETAILED,
  ],
  [PO_MANAGER]: [
    RETAIL_PURCHASE_REQUEST_LIST,
    INBOUND_LIST,
    PURCHASE_ORDER_LIST,
    SUPPLIER_PORTAL,
    BIDDING_REQUEST,
    WMS,
    //PROCUREMENT,
    DISTRIBUTOR_PURCHASE_REQUEST,
    CONSOLIDATED_PURCHASE_REQUEST,
    VIGO_MASTER_QUOTATION,
    DISTRIBUTOR_PURCHASE_ORDER,
    VIGO_PURCHASE_ORDER,
    REPORT_CLAIMS,
    REPORT_GST_PURCHASES,
    REPORT_GST_SALES,
    REPORT_GST_SALES_HUB,
    REPORT_INVENTORY,
    REPORT_SUMMARY,
    REPORT_RIDER,
    INVENTORY_LIST,
    DELIVERY_MANAGEMENT_HUB,
    PRE_ORDERS,
    RETURN_ORDER_LIST,
    CREDIT_DEBIT_NOTE,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_SALES_SUMMARY_OUTLET,
    REPORT_SALES_SUMMARY_SKU,
    REPORT_PURCHASE_RETURN,
    REPORT_PURCHASE_RECONCILIATION,
    REPORT_PRODUCT_SUMMARY,
    REPORT_INVOICE_LOADING,
    REPORT_INVENTORY_SNAPSHOT,
    REPORT_GST_SUMMARY_BY_HSN,
    REPORT_GST_SALES_RETURN_HUB,
    REPORT_GST_SALES_RETURN,
    REPORT_GST_SALES_REGISTER_HUB,
    REPORT_GST_SALES_REGISTER_DETAILED_HUB,
    REPORT_GSTR_SALES_REGISTER,
    REPORT_GSTR_SALES_REGISTER_SUMMARY,
    REPORT_GST_SALES_RETURN_SUMMARY,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_CLAIMS_RETURN,
    REPORT_CLAIM,
    REPORT_PURCHASE_REGISTER_DETAILED,
  ],
  [FINANCE]: [
    INVENTORY_ADJUSTMENT,
    RETAIL_PURCHASE_REQUEST_LIST,
    DELIVERY_MANAGEMENT_HUB,
    SUPPLIER_PORTAL,
    PURCHASE_ORDER_LIST,
    WMS,
    INBOUND_LIST,
    INVENTORY_LIST,
    BUY_IN_INVOICE,
    SELL_OUT_INVOICE,
    PAYMENT_REQUEST,
    PACKAGE_LIST,
    MARKETING,
    TRANSPORTATION_VENDOR,
    VIGO_DELIVERY,
    PAYOUT_STATEMENT,
    FINANCE_TASK_LIST,
    CLAIMS_MANAGEMENT,
    REPORT_CLAIMS,
    REPORT_GST_PURCHASES,
    REPORT_GST_SALES,
    REPORT_GST_SALES_HUB,
    REPORT_INVENTORY,
    REPORT_SUMMARY,
    REPORT_RIDER,
    RETURN_ORDER_LIST,
    DISTRIBUTOR_MARGIN,
    TRADE_ORDERS,
    DISTRIBUTOR_FEE,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_SALES_SUMMARY_OUTLET,
    REPORT_SALES_SUMMARY_SKU,
    REPORT_PURCHASE_RETURN,
    REPORT_PURCHASE_RECONCILIATION,
    REPORT_PRODUCT_SUMMARY,
    REPORT_INVOICE_LOADING,
    REPORT_INVENTORY_SNAPSHOT,
    REPORT_GST_SUMMARY_BY_HSN,
    REPORT_GST_SALES_RETURN_HUB,
    REPORT_GST_SALES_RETURN,
    REPORT_GST_SALES_REGISTER_HUB,
    REPORT_GST_SALES_REGISTER_DETAILED_HUB,
    REPORT_GSTR_SALES_REGISTER,
    REPORT_GSTR_SALES_REGISTER_SUMMARY,
    REPORT_GST_SALES_RETURN_SUMMARY,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_CLAIMS_RETURN,
    REPORT_CLAIM,
    REPORT_PURCHASE_REGISTER_DETAILED,
  ],
  [CONTENT]: [WMS, INBOUND_LIST, INVENTORY_LIST],
  [RIDER_ROLE]: [HOME, DELIVERY_MANAGEMENT],
  [GUEST]: [HOME],
  [SOURCING_MANAGER]: [
    SUPPLIER_PRODUCT_LIST,
    INBOUND_LIST,
    INVENTORY_LIST,
    // Master Data
    PRODUCT_LIST,
    SUPPLIER_LIST,
    // Supplier Portal
    PURCHASE_ORDER_LIST,
    BIDDING_REQUEST,
    BIDDING_INVITATION_LIST,
    //PROCUREMENT,
    DISTRIBUTOR_PURCHASE_REQUEST,
    CONSOLIDATED_PURCHASE_REQUEST,
    VIGO_MASTER_QUOTATION,
    DISTRIBUTOR_PURCHASE_ORDER,
    VIGO_PURCHASE_ORDER,
    // Logistics
    TRANSPORTATION_VENDOR,
    REPORT_CLAIMS,
    REPORT_GST_PURCHASES,
    REPORT_GST_SALES,
    REPORT_GST_SALES_HUB,
    REPORT_INVENTORY,
    REPORT_SUMMARY,
    REPORT_RIDER,
    RETURN_ORDER_LIST,
    CREDIT_DEBIT_NOTE,
    TASK_LIST,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_SALES_SUMMARY_OUTLET,
    REPORT_SALES_SUMMARY_SKU,
    REPORT_PURCHASE_RETURN,
    REPORT_PURCHASE_RECONCILIATION,
    REPORT_PRODUCT_SUMMARY,
    REPORT_INVOICE_LOADING,
    REPORT_INVENTORY_SNAPSHOT,
    REPORT_GST_SUMMARY_BY_HSN,
    REPORT_GST_SALES_RETURN_HUB,
    REPORT_GST_SALES_RETURN,
    REPORT_GST_SALES_REGISTER_HUB,
    REPORT_GST_SALES_REGISTER_DETAILED_HUB,
    REPORT_GSTR_SALES_REGISTER,
    REPORT_GSTR_SALES_REGISTER_SUMMARY,
    REPORT_GST_SALES_RETURN_SUMMARY,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_CLAIMS_RETURN,
    REPORT_CLAIM,
    REPORT_PURCHASE_REGISTER_DETAILED,
  ],
  [LOGISTICS_MANAGER]: [
    //procurement
    VIGO_MASTER_QUOTATION,
    DISTRIBUTOR_PURCHASE_ORDER,
    VIGO_PURCHASE_ORDER,
    RIDER_MANAGEMENT,
    VEHICLE_MANAGEMENT,
    DELIVERY_MANAGEMENT,
    // Logistics
    TRANSPORTATION_VENDOR,
    VIGO_DELIVERY,
    // Settings
    REPORT_CLAIMS,
    REPORT_GST_PURCHASES,
    REPORT_GST_SALES,
    REPORT_GST_SALES_HUB,
    REPORT_INVENTORY,
    REPORT_SUMMARY,
    REPORT_RIDER,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_SALES_SUMMARY_OUTLET,
    REPORT_SALES_SUMMARY_SKU,
    REPORT_PURCHASE_RETURN,
    REPORT_PURCHASE_RECONCILIATION,
    REPORT_PRODUCT_SUMMARY,
    REPORT_INVOICE_LOADING,
    REPORT_INVENTORY_SNAPSHOT,
    REPORT_GST_SUMMARY_BY_HSN,
    REPORT_GST_SALES_RETURN_HUB,
    REPORT_GST_SALES_RETURN,
    REPORT_GST_SALES_REGISTER_HUB,
    REPORT_GST_SALES_REGISTER_DETAILED_HUB,
    REPORT_GSTR_SALES_REGISTER,
    REPORT_GSTR_SALES_REGISTER_SUMMARY,
    REPORT_GST_SALES_RETURN_SUMMARY,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_CLAIMS_RETURN,
    REPORT_CLAIM,
    REPORT_PURCHASE_REGISTER_DETAILED,
  ],
  [MASTER_DISTRIBUTOR_HUB]: [
    // Master Data
    SUPPLIER_PRODUCT_LIST,
    // Supplier Portal
    PURCHASE_ORDER_LIST,
    // WMS
    INBOUND_LIST,
    INVENTORY_LIST,
    // Return
    RETURN_ORDER_LIST,
    REPORT_GST_PURCHASES,
    REPORT_GST_SALES_HUB,
    REPORT_INVENTORY,
    REPORT_SUMMARY,
    REPORT_RIDER,
    TASK_LIST,
    DELIVERY_MANAGEMENT_HUB,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_SALES_SUMMARY_OUTLET,
    REPORT_SALES_SUMMARY_SKU,
    REPORT_PURCHASE_RETURN,
    REPORT_PURCHASE_RECONCILIATION,
    REPORT_PRODUCT_SUMMARY,
    REPORT_INVOICE_LOADING,
    REPORT_INVENTORY_SNAPSHOT,
    REPORT_GST_SUMMARY_BY_HSN,
    REPORT_GST_SALES_RETURN_HUB,
    REPORT_GST_SALES_RETURN,
    REPORT_GST_SALES_REGISTER_HUB,
    REPORT_GST_SALES_REGISTER_DETAILED_HUB,
    REPORT_GSTR_SALES_REGISTER,
    REPORT_GSTR_SALES_REGISTER_SUMMARY,
    REPORT_GST_SALES_RETURN_SUMMARY,
    REPORT_GST_PURCHASE_REGISTER,
    REPORT_CLAIMS_RETURN,
    REPORT_CLAIM,
    REPORT_PURCHASE_REGISTER_DETAILED,
  ],
  [MARKETING_ROLE]: [
    PAYOUT_STATEMENT,
    AGENT_INCENTIVES,
    INCENTIVES_CONFIG,
    AGENT_GROUP,
    TRADE_ORDERS,
  ],
}

export const ROLES = Object.keys(isIndia ? ACL_INDIA : ACL).sort()

export const isAdmin = (roles: string[]) => roles.includes(ADMIN_ROLE)
export const isPOManager = (roles: string[]) => roles.includes(PO_MANAGER)
export const isFinance = (roles: string[]) => roles.includes(FINANCE)
export const isBGM = (roles: string[]) => roles.includes(BGM)
export const isSourcing = (roles: string[]) => roles.includes(SOURCING_MANAGER)

export const isAdminMarketplace = (roles: string[]) =>
  !isIndia && roles.includes(ADMIN_MARKETPLACE)
export const isSaleSupervisor = (roles: string[]) =>
  !isIndia && roles.includes(SALE_SUPERVISOR)

export const isDistributorStaff = (roles: string[]) =>
  isIndia && roles.includes(DISTRIBUTOR_STAFF)
export const isRoleWarehouseOwnership = (roles: string[]) =>
  roles.some((r) =>
    [ADMIN_MARKETPLACE, SALE_SUPERVISOR, DISTRIBUTOR_STAFF].includes(r)
  )

export const isDistributor = (roles: string[]) =>
  roles.includes(EXTERNAL_DISTRIBUTOR)
export const isSupplier = (roles: string[]) => roles.includes(EXTERNAL_SUPPLIER)

export const getRedirectRoutes = (
  aclRoutes: string[],
  currentRoute: string
): string[] => {
  return aclRoutes.reduce((prev, route) => {
    if (route.includes(currentRoute) && route !== currentRoute) {
      return [...prev, route]
    }

    return prev
  }, [])
}

export default isIndia ? ACL_INDIA : ACL
